import React from 'react';
import Alert from 'react-bootstrap/Alert';



class NotReady extends React.Component{
  render(){
    return(
      <div>
      <Alert variant="dark" className="mt-3 shadow-lg">
        <Alert.Heading>هذا المحتوى غير موجود حاليا</Alert.Heading>
        <p> فريق عمل الموقع سيعمل على إضافة هذا المحتوى قريبا.</p>
        <hr/>
        <Alert.Heading>Ce contenu n'existe pas actuellement</Alert.Heading>
        <p>L'équipe du site travaillera bientôt à l'ajout de ce contenu. </p>
        <hr/>
        <Alert.Heading>This content does not currently exist</Alert.Heading>
        <p> The site team will work on adding this content soon.</p>

      </Alert>



      </div>

    );
  }
}

export default NotReady;
